<template>
  <div class="col page eh-ds">
    <add-user-form
      v-if="registerContact"
      :lock-account-type-to-contact="true"
      :prefill-contact="registerContact"
      @close="closeRegisterForm"
    />
    <div
      ref="formContainer"
      class="form"
    >
      <div class="header2">
        <h1 class="title">
          Contacts
        </h1>
      </div>
      <user-contact
        :top-or-bottom="'top'"
        :current-top-or-bottom="topOrBottom"
        :contact="newContact"
        :existing="false"
        :all-data="allData"
        :someone-editing="someoneEditing"
        :empty-contact="emptyContact"
        :all-contacts="contacts"
        @begin-edit="handleBeginEdit"
        @cancel-edit="handleCancelEdit"
        @delete-contact="handleDelete"
        @load-model="handleLoadModel"
        @contact-saved="handleSaved"
        @register-contact="handleRegisterContact"
      />
      <user-contact
        v-for="contact in contacts"
        :key="contact.id"
        :contact="contact"
        :existing="true"
        :all-data="allData"
        :someone-editing="someoneEditing"
        :empty-contact="emptyContact"
        :all-contacts="contacts"
        :top-or-bottom="'neither'"
        :current-top-or-bottom="topOrBottom"
        @begin-edit="handleBeginEdit"
        @cancel-edit="handleCancelEdit"
        @delete-contact="handleDelete"
        @load-model="handleLoadModel"
        @contact-saved="handleSaved"
        @register-contact="handleRegisterContact"
      />
    </div>
  </div>
</template>

<script>
import { getPrimaryContact } from "@/data/getters";
import UserContact from "./UserContact.vue";
import AddUserForm from "@/components/private-layouts/welcome/AddUserForm.vue";
import { uuid } from "vue-uuid";
import {
  updateLicenseStatus,
  getLicenses,
  getContacts,
  createContact,
  updateContact,
  deleteContact,
  renameContact,
  setPrimaryContact,
} from "@/api/userApi";
import { Collapse } from "bootstrap";

export default {
  name: "UserContacts",
  components: {
    "user-contact": UserContact,
    AddUserForm,
  },
  props: {
    restricted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      allData: this.$store.getters["login/getAllData"],
      contacts: [],
      registerContact: null,
      newContact: this.createEmptyContact(),
      emptyContact: this.createEmptyContact(),
      someoneEditing: false,
      topOrBottom: "neither",
    };
  },
  computed: {},
  created() {
    this.loadModel();
  },
  methods: {
    handleSaved() {
      this.someoneEditing = false;
      this.newContact = this.createEmptyContact();
      this.loadModel();
    },
    handleBeginEdit(params) {
      this.topOrBottom = params.topOrBottom;
      this.someoneEditing = true;
    },
    handleCancelEdit() {
      this.someoneEditing = false;
    },
    handleRegisterContact(contact) {
      this.registerContact = contact;
    },
    closeRegisterForm() {
      this.registerContact = null;
    },
    /*
    handleSave({contact,existing}) {
      if(existing)
        updateContact(contact).then((response)=>{
          if(response.length) {
            let msgs = [...new Set(Object.values(response))];
            alert(msgs.join("\m"));
          }
          else {
            this.loadModel();
          }
        })
      else
        createContact(contact).then((response)=>{
          if(response.length) {
            
          }
          this.loadModel)
    },*/
    handleDelete({ contact }) {
      if (confirm("Are you sure you would like to delete this contact?")) {
        const accountnumber = this.allData?.patient?.externId2 || this.allData?.patient?.externid2 || '';
        const patientUniqueId = String(this.allData?.patient?.externId || this.allData?.patient?.externid || this.allData?.patient?.psersonalID || this.allData?.patient?.id || '').trim();

        deleteContact({
          id: contact.id,
          contact_uuid: contact.id,
          accountnumber,
          patient_unique_id: patientUniqueId,
          patientUniqueId,
        }).then(() => {
          this.loadModel();
          this.someoneEditing = false;
        }).catch(err => {
          console.error("Delete contact error:", err);
          alert("Error deleting contact");
        });
      }
    },
    handleLoadModel() {
      this.loadModel();
    },
    loadModel() {
      const accountnumber = this.allData?.patient?.externId2 || this.allData?.patient?.externid2 || '';
      const patientUniqueId = String(this.allData?.patient?.externId || this.allData?.patient?.externid || this.allData?.patient?.psersonalID || this.allData?.patient?.id || '').trim();

      getContacts({ accountnumber, patient_unique_id: patientUniqueId, patientUniqueId }).then((contacts) => {
        const rawContacts = Array.isArray(contacts) ? contacts : [];
        const emptyContact = this.createEmptyContact();
        for (let contactIndex = 0; contactIndex < rawContacts.length; contactIndex++) {
          for (let fieldName in emptyContact) {
            if (rawContacts[contactIndex][fieldName] === undefined)
              rawContacts[contactIndex][fieldName] = emptyContact[fieldName];
          }
        }
        this.contacts = rawContacts;
        this.primaryContact = getPrimaryContact(rawContacts);
      }).catch(err => {
        console.error("Failed to load contacts:", err);
        this.contacts = [];
      });
    },
    licenseStatusClass(contact) {
      switch (contact.status) {
        case "UNENCUMBERED":
          return "text-success";
        case "EXPIRED":
        case "ENCUMBERED":
          return "text-danger";
      }
      return "text-dark";
    },
    createEmptyContact() {
      return JSON.parse(
        JSON.stringify({
          id: "",
          firstName: "",
          lastName: "",
          relationType: 0,
          primaryPhone: "",
          primaryPhoneType: 0,
          secondaryPhone: "",
          secondaryPhoneType: 0,
          email: "",
          address1: "",
          address2: "",
          city: "",
          state: 0,
          zip: "",
          ssn: "",
          dob: "",
          license: "",
          licenseState: 0,
          licenseId: 0,
          primaryContact: false,
        })
      );
    },
    isRelated(contact, items) {
      if (contact && contact.relationType && items) {
        let f = this.relation.find((r) => r.id === contact.relationType);
        return f && items.includes(f.value);
      }
      return false;
    },
    isLicensed(contact) {
      return this.isRelated(contact, [
        "Licensed Practical Nurse",
        "Registered Nurse",
        "Geriatric Care Manager",
        "Physical Therapist",
        "Occupational Therapist",
        "Dietician",
        "Social Worker",
        "Speech Therapist",
      ]);
    },
    queryLicense(ind) {
      getLicenses({
        license: contact.license,
        state: contact.licenseState,
        firstName: contact.firstName,
        lastName: contact.lastName,
      })
        .then((resp) => {
          if (!resp || resp.length == 0 || resp[0].length == 0)
            !alert("No licensed individual with the inputted id and state");
          else {
            !alert("Available licensed individual information loaded");
            contact.firstName = resp.fst || "";
            contact.lastName = resp.lst || "";
            contact.primaryPhone = resp.phone1 || "";
            contact.secondaryPhone = resp.phone2 || "";
            contact.city = resp.city || "";
            contact.address1 = resp.address1 || "";
            contact.contactEmail = resp.email || "";
            contact.address2 = resp.addr2 || "";
            contact.zip = resp.zip || "";
            contact.state = resp.state || 0;
            contact.primaryPhoneType = resp.phone1type || 0;
            contact.secondaryPhoneType = resp.phone2type || 0;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleClearPriority({ contact }) {
      const accountnumber = this.allData?.patient?.externId2 || this.allData?.patient?.externid2 || '';
      const patientUniqueId = String(this.allData?.patient?.externId || this.allData?.patient?.externid || this.allData?.patient?.psersonalID || this.allData?.patient?.id || '').trim();

      setPrimaryContact({
        id: contact.id,
        contact_uuid: contact.id,
        primaryContact: false,
        primary_contact: false,
        accountnumber,
        patient_unique_id: patientUniqueId,
        patientUniqueId,
      })
        .then((a) => {
          if (!a || a.length == 0 || a.status === "Successful") {
            this.handleLoadModel();
          } else {
            let msgs = [...new Set(Object.values(a))];
            alert(msgs.join("\n"));
          }
        })
        .catch((b) => {
          alert("Error: Please contact website administration");
          console.dir(b);
        });
    },
    handleSetPriority({ contact }) {
      const accountnumber = this.allData?.patient?.externId2 || this.allData?.patient?.externid2 || '';
      const patientUniqueId = String(this.allData?.patient?.externId || this.allData?.patient?.externid || this.allData?.patient?.psersonalID || this.allData?.patient?.id || '').trim();

      setPrimaryContact({
        id: contact.id,
        contact_uuid: contact.id,
        primaryContact: true,
        primary_contact: true,
        accountnumber,
        patient_unique_id: patientUniqueId,
        patientUniqueId,
      }).then((a) => {
        if (!a || a.length == 0 || a.status === "Successful") {
          this.handleLoadModel();
        } else {
          let msgs = [...new Set(Object.values(a))];
          alert(msgs.join("\n"));
        }
      }).catch((b) => {
        alert("Error: Please contact website administration");
        console.dir(b);
      });
    },
    cancelAdd() {
      if (!this.justLooking(this.newContact)) throw "Canceling bad add";
      // this.$set(contact, "original");
      this.contact = 'original'
    },
    handleNewSubmit() {
      createContact(this.newContact)
        .then((a) => {
          console.log(a);
          if (
            !a ||
            a.length == 0 ||
            a.status === "Successful" ||
            a.hasOwnProperty("id") ||
            a.hasOwnProperty("newId") ||
            a.hasOwnProperty("newlicenseid")
          ) {
            if (this.newStatus) {
              updateLicenseStatus({
                state: this.states.find(
                  (state) => state.name == formData.get("licenseState")
                ).id,
                license: formData.get("licenseNumber"),
                status: this.newStatus,
              }).then((b) => {
                if (!alert("New contact added.")) {
                  this.newQuery = false;
                  window.location.reload();
                }
              });
            } else {
              if (!alert("New contact added.")) {
                this.newQuery = false;
                window.location.reload();
              }
            }
          } else {
            let msgs = [...new Set(Object.values(a))];
            let alertMsg = "";
            for (var m of msgs) {
              alertMsg = alertMsg + m + "\n";
            }
            alert(alertMsg);
          }
        })
        .catch((b) => {
          alert("Error: Please contact website administration");
          console.dir(b);
        });
    },
    handleContactEdit(contact) {
      // this.$set(contact, "original", JSON.stringify(contact));
      contact['original'] = JSON.stringify(contact)
    },
    handleContactCancel(contact) {
      this.$delete(contact, "original");
    },
    buttonClass(contact, name) {
      // switch(name) {
      //   case 'verify':
      //     return contact.licenseState && contact.license ? '' : 'd-none';
      //   case 'save':
      //     this.createEmptyContact
      // }
      // if(contact.isNew) {
      //   switch(name) {
      //     case 'save':
      //     case 'cancel':
      //     case 'edit':
      //     case 'query':
      //       this.isEditing() && !this.justLooking(contact) ||
      //     case 'verify':
      //       return contact.licenseState && contact.license ? '' : 'd-none';
      //   }
      // }
      // else {
      //   switch(name) {
      //     // case 'query':
      //     // case 'verify':
      //     case 'edit':
      //       return contact.original ? 'd-none' : '';
      //     case 'cancel':
      //     case 'submit':
      //       return contact.original ? '' : 'd-none';
      //     case 'delete':
      //       return this.isImmutable(contact)  ? 'd-none' : ''
      //   }
      // }
      // throw 'Bad button class';
    },
    handleSubmit(_contact) {
      let contact = {};
      for (const key in this.createEmptyContact) {
        contact[key] = _contact[key];
      }
      (contact.isNew ? createContact(contact) : updateContact(contact))
        .then((a) => {
          if (contact.isNew) {
            if (
              a.length === 0 ||
              a.hasOwnProperty("id") ||
              a.hasOwnProperty("newId") ||
              a.hasOwnProperty("newlicenseid")
            ) {
              if (contact.status) {
                updateLicenseStatus({
                  state: contact.licenseState,
                  license: contact.license,
                  status: contact.status,
                });
              }
            }
          }
          if (!a || a.length == 0 || a.status === "Successful") {
            if (!alert("Contact updated.")) {
              window.location.reload();
            }
          } else {
            let msgs = [...new Set(Object.values(a))];
            let alertMsg = "";
            for (var m of msgs) {
              alertMsg = alertMsg + m + "\n";
            }
            alert(alertMsg);
          }
        })
        .catch((b) => {
          alert("Error: Please contact website administration");
          console.dir(b);
        });
    },
  },
};
</script>

<style scoped lang="scss">
/* Colors/fonts live in the stylebook (.eh-ds in brand-ds.scss). Layout stays here. */

.page {
  background-color: #fff;
  border: none;
  box-shadow: none;
  margin: 1.5rem auto;
  padding: 2rem;
  margin-bottom: 100px;
}

.header2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.title {
  font-size: 2.5rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 0;
}

.profile__label {
  font-size: 0.8rem;
}

.profile__checkbox {
  font-size: 0.8rem;
}

input,
select {
  font-size: 0.8rem;
}

.btn-container {
  margin-top: 1rem;

  .btn {
    font-size: 0.8rem;
    margin: 2px;
  }

  padding-bottom: 3rem;
}

.cancel {
  visibility: hidden;
}

.submit {
  visibility: hidden;
}

.delete {
  visibility: hidden;
}

.licenseInfo {
  display: flex;
  justify-content: center;
}

.statusInfo {
  justify-content: center;
}

.button-container {
  display: flex;
  align-items: flex-end;
}
</style>
